import type { TEnvConfig, TAppEnvironment, TAuthEnvironment } from './env.config.types';

const getAuthEnv = (): TAuthEnvironment => {
	const authEnv = import.meta.env.VITE_AUTH_ENV;

	if (!authEnv) {
		throw new Error('VITE_AUTH_ENV is required. Check your .env file.');
	}

	return authEnv as TAuthEnvironment;
};

const ENV: TEnvConfig = {
	APP_ENV: (import.meta.env.VITE_APP_ENV ?? 'development') as TAppEnvironment,
	AUTH_ENV: getAuthEnv(),
	URL_LOGIN: import.meta.env.VITE_URL_LOGIN ?? '',
	URL_PORTAL: import.meta.env.VITE_URL_PORTAL ?? 'https://www.webmotors.com.br',
	URL_VENDER: import.meta.env.VITE_URL_VENDER ?? 'https://vender.webmotors.com.br',
	URL_GARAGEM: import.meta.env.VITE_URL_GARAGEM ?? 'https://hportal.webmotors.com.br/garagem',
	API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'https://hportal.webmotors.com.br/api/',
	API_PF_URL: import.meta.env.VITE_API_PF_URL ?? 'https://hportal.webmotors.com.br/api/pf/',
	API_CONSENTS_URL:
		import.meta.env.VITE_API_CONSENTS_URL ?? 'https://hportal.webmotors.com.br/api/account/',
	API_LIVENESS_URL:
		import.meta.env.VITE_API_LIVENESS_URL ??
		'https://tkz7njoum4.execute-api.us-east-1.amazonaws.com/hml',
	URL_LIVENESS:
		import.meta.env.VITE_URL_LIVENESS ??
		'https://hportal.liveness.webmotors.com.br/minha-conta/dados',
	URL_DELETE_ACCOUNT:
		import.meta.env.VITE_URL_DELETE_ACCOUNT ??
		'https://webmotors.zendesk.com/hc/pt-br/requests/new?ticket_form_id=360001066911',
	URL_FOTO_PEQUENA:
		import.meta.env.VITE_URL_FOTO_PEQUENA ?? 'https://himage.webmotors.com.br/_fotos/anunciousados/pequena/',
	URL_FOTO_PEQUENA_MOTO:
		import.meta.env.VITE_URL_FOTO_PEQUENA_MOTO ??
		'https://himage.webmotors.com.br/_fotos/anuncioMotousados/pequena/',
	LIVENESS_CERTTA_SDK_URL:
		import.meta.env.VITE_LIVENESS_CERTTA_SDK_URL ??
		'https://repo.combateafraude.com/javascript/release/caf-face-liveness/0.15.1/caf-face-liveness_0.15.1.umd.js',
	LIVENESS_IDWALL_SDK_URL:
		import.meta.env.VITE_LIVENESS_IDWALL_SDK_URL ?? 'https://sdkweb-lib.idwall.co/index.js',
	LIVENESS_IDWALL_TOKEN: import.meta.env.VITE_LIVENESS_IDWALL_TOKEN ?? '',
	DATADOG_ENV: import.meta.env.VITE_DATADOG_ENV ?? 'development',
	DATADOG_CLIENT_TOKEN: import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? '',
	DATADOG_APPLICATION_ID: import.meta.env.VITE_DATADOG_APPLICATION_ID ?? '',
	DATADOG_SERVICE: import.meta.env.VITE_DATADOG_SERVICE ?? 'wm-consumer-dados-ui',
	DATADOG_SITE: import.meta.env.VITE_DATADOG_SITE ?? 'datadoghq.com',
	DATADOG_SESSION_SAMPLE_RATE: Number(import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE ?? 20),
	DATADOG_SESSION_REPLAY_SAMPLE_RATE: Number(import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 20),
	DROZ_COPI_ID: import.meta.env.VITE_DROZ_COPI_ID ?? '9519d9d99c9545327d4b361416f9ecc8dbf5ec9a',
	DROZ_COPI_ID_BIOMETRIA_INCONCLUSIVA: import.meta.env.VITE_DROZ_COPI_ID_BIOMETRIA_INCONCLUSIVA ?? 'b8b9aa0b8eb5701c338e1d065cf422b4ccf6261e',
} as const;

export { ENV };
